import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { SpinnerWidth } from '../../../../../ui/gzProgressSpinner/types';
import { LinkColor, LinkType } from '../../../../../ui/gzLinkComponent/types';
import { FontSizes, FontWeights } from '../../../../../types/common/types';

export const templatePlansAndPurchaseTab = document.createElement('template');

templatePlansAndPurchaseTab.innerHTML = `
  <style>${styles}</style>
  <style>${commonStyles}</style>

  <div class='wrapper'>

      <div class='in-product-buy-loading-container'>
        <gz-progress-spinner spinnerWidth='${SpinnerWidth.MEDIUM}'></gz-progress-spinner>
      </div>

      <div class='in-product-buy-error-container'>
        <gz-image-repo id='in-product-buy-error-image'>
          <gz-title id='in-product-buy-error-title' fontSize='${FontSizes.HEADING_4}' fontWeight="${FontWeights.MEDIUM}"></gz-title>
          <span>
            <span id='in-product-buy-error-text'></span>
            <gz-link id='in-product-buy-error-link' type="${LinkType.UNDERLINE}" color="${LinkColor.PRIMARY}"></gz-link>
          </span>
        </gz-image-repo>
      </div>

      <div class='in-product-buy-main-container'>
        <gz-purchase-page></gz-purchase-page>
      </div>

  </div>
`;
